import { render, staticRenderFns } from "./LegalExpert.vue?vue&type=template&id=0a256788"
import script from "./LegalExpert.vue?vue&type=script&lang=js"
export * from "./LegalExpert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports